import React, { useEffect } from 'react'
import SelectInput from '../inputs/select-input'
import MultiSelect from '../inputs/multi-select'

const MultiMatch = ({data, types, columns, values, onRemove, onChange, onTransform}) => {
  const singleConditions = [['=', 'is'], ['<>', 'is not']]
  const multiConditions = [['IN', 'is any of'], ['NOT IN', 'is none of']]
  const conditions = [...singleConditions, ...multiConditions]
  const singleValue = singleConditions.map(c => c[0]).includes(data.condition || conditions[0][0])
  const multiOptions = values.map(value => { return {value: value[0], label: value[1]} })

  const query = (params) => {
    if (singleConditions.map(c => c[0]).includes(params.condition)) 
      return `${params.column} ${params.condition} '${params.value}'`

    if (params.value && params.value.length) {
      const multiValue = params.value.map(p => `'${p.value}'`).join(',')
      return `${params.column} ${params.condition} (${multiValue})`
    }
  }

  useEffect(() => {
    if (!data.condition) {
      const defaultParam = {...data, condition: conditions[0][0], value: values[0][0], completed: true}
      const defaultQuery = query(defaultParam)
      onChange({...defaultParam, query: defaultQuery})
    }
  }, [data.column])

  const isCompleted = (params) => {
    if (singleConditions.map(c => c[0]).includes(params.condition)) return true
    if (params.value && params.value.length) return true
    return false
  }

  const changeCondition = (value) => {
    const staysSingle = singleValue && singleConditions.map(c => c[0]).includes(value)
    const staysMulti = !singleValue && multiConditions.map(c => c[0]).includes(value)
    if (staysSingle || staysMulti) return changeData({condition: value})
    changeData({condition: value, value: undefined})
  }

  const changeData = (params) => {
    const newData = {...data, ...params, completed: false, query: undefined}
    if (isCompleted(newData)) {
      newData.completed = true
      newData.query = query(newData)
    }
    onChange({...data, ...newData})
  }

  return (
    <div className='filter-row'>
      { !data.type && <span className='where'>Where</span> }
      { data.type && 
        <SelectInput
          name='type'
          options={types}
          value={data.type}
          onChange={e => changeData({type: e.target.value})}
        />      
      }
      <SelectInput
        name='column'
        options={columns}
        value={data.column}
        onChange={e => onTransform(e.target.value)}
      />
      <SelectInput
        name='condition'
        options={conditions}
        value={data.condition || conditions[0][0]}
        onChange={e => changeCondition(e.target.value)}
      />
      { singleValue &&
        <SelectInput
          name='value'
          options={values}
          value={data.value || values[0][0]}
          onChange={e => changeData({value: e.target.value})}
        />
      }
      { !singleValue &&
        <MultiSelect
          value={data.value}
          options={multiOptions}
          onChange={values => changeData({value: values})}
        />
      }
      <button className='remove' onClick={onRemove}><i className='fa fa-trash-o' /></button>
    </div>
  )
}

export default MultiMatch
